import { call, put, select } from 'redux-saga/effects';
import {
  getCardPaymentError as getCardPaymentErrorAda,
} from '@bitComponents/adabyron/payment';
import { WEB_SERVICES } from './webServices';


const contextStore = state => state.context.data;

export function* getCardPaymentError(params) {
  const {
    reduxUpdate, normalizeHttpErrors, idError,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const data = {
      idError,
    };
    const context = yield select(contextStore);
    const response = yield call(getCardPaymentErrorAda, data, context);
    yield put(successUpdate(response));
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_CARD_PAYMENT_ERROR, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }
  }
}
